export const HEADER_BLOCK_S21 = {
  "temp":{
    "templateId":21
  },
  "blockType": "HEADER",
  "blockDesign": "header_01",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#0F0F0F",
    "padding": "120px 20px 120px 20px"
  },
  "position": "center",
  "headingsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center",
    "max-width": "896px",
    "margin": "4px auto 4px auto"
  },
  "headingsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "headingsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "headings": [
    {
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "12px 20px 12px 20px",
        "font-weight": "400",
        "color": "#f5dbff",
        "font-family-cust": "",
        "font-family": "'Lato', sans-serif",
        "margin": "0px 0px 0px 0px",
        "font-family-bk": "'Lato', sans-serif",
        "background-color": "#262626",
        "border-radius": "1.5rem"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "12px 20px 12px 20px"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "padding": "12px 20px 12px 20px"
      },
      "text": "☆ 4.9/5 from over 600 reviewsSolutions",
      "alignStyleProps": {
        "text-align": "center"
      }
    },
    {
      "text": "Transforming Businesses with Innovative Software ",
      "styleProps": {
        "font-size": "4.5rem",
        "line-height": "1",
        "padding": "20px 0px 40px 0px",
        "font-weight": "600",
        "color": "#ffffff",
        "font-family-cust": "",
        "font-family": "'Lato', sans-serif",
        "margin": "0px 0px 0px 0px",
        "font-family-bk": "'Lato', sans-serif"
      },
      "stylePropsTab": {
        "font-size": "3.75rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "3rem",
        "line-height": "1"
      }
    },
    {
      "text": "Check out some of our notable projects and success stories. From startups to enterprises, we've helped numerous organizations achieve their goals.",
      "styleProps": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "color": "#cccccc",
        "margin": "0px 0px 0px 0px",
        "font-family": "'Lato', sans-serif",
        "font-weight": "400",
        "padding": "20px 0px 40px 0px"
      },
      "stylePropsTab": {
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "dynamicText": {
    "styleProps": {
      "font-size": "1.875rem",
      "line-height": "2.25rem",
      "padding": "10px 0px 10px 0px",
      "text-align": "center"
    },
    "stylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "stylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "strings": []
  },
  "descriptionsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "descriptionsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptionsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptions": [],
  "buttonsStyleProps": {},
  "buttons": [
    {
      "text": "Get Started Today",
      "styleProps": {
        "color": "#333333",
        "border-color": "#3b82f680",
        "background-color": "#f5dbff",
        "border-width": "0px",
        "border-radius": "1rem"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "textsStyleProps": {
    "text-align": "center"
  },
  "texts": [],
  "editFormName": "HEADER_FORM_01",
  "metaDataId": 1746167842860,
  "blockId": 1746167842860,
  "textBlock": {
    "descriptions": [
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      },
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      }
    ],
    "headings": [
      {},
      {},
      {}
    ]
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  }
}